import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import Tab from '../Tab';
import Layout from '../Layout';
import ErrorAlert from '../../components/ErrorAlert';
import { get, remove, resetState } from '../../modules/admins';

class AdminsTab extends Tab {
  columns = [
    { key: 'id', title: 'ID', dataIndex: 'id' },
    {
      key: 'full_name',
      title: 'Name',
      dataIndex: 'full_name',
      render: (fullName, data) => <Link to={`/admins/${data.id}`}>{fullName}</Link>,
    },
    { key: 'email', title: 'Email', dataIndex: 'email', width: '0' },
    { key: 'phone_number', title: 'Phone Number', dataIndex: 'phone_number' },
    this.tableActions(),
  ];

  render() {
    return (
      <Layout>
        <ErrorAlert error={this.props.error} />
        <Row type="flex" justify="end">
          <Col md={3} lg={2}>
            {this.renderCreateButton()}
          </Col>
        </Row>
        <Row>
          <Col>
            {this.renderDataTable()}
          </Col>
        </Row>
      </Layout>
    );
  }
}

export default connect(state => state.admins, { get, remove, resetState })(AdminsTab);



// WEBPACK FOOTER //
// ./src/containers/Admins/AdminsTab.js